import PageUser from 'components/Pages/User/PageUser'
import UserView from './UserView'

const userRoutes = [
  { path: '/users', component: PageUser },
  { path: '/users/:_id', component: UserView }
]

export default userRoutes
